import React from 'react';
import LoginContainer from '../container/LoginContainer';

function Login() {
  return <LoginContainer />;
}

export default Login;
